/**
 * WidgetIntegration: {
 *  enabledWidgetIntegrationProvider: {
 *    <course_path>: {
 *      data: [],
 *      isLoading: []
 *    }
 *  },
 *  blockWidgetIntegrations: {
 *    <block-block-id>: {
 *      data: [],
 *      isLoading:
 *    }
 *  }
 * }
 */

import { DeepReadonly } from 'utility-types';

export const INITIAL_STATE: WidgetIntegrationsState = {
  enabledWidgetIntegrationProviders: {},
  blockWidgetIntegrations: {},
};

export type WidgetIntegrationsState = DeepReadonly<{
  enabledWidgetIntegrationProviders: {
    [coursePath: string]: {
      data: Readonly<WidgetIntegrationProvider[]>;
    };
  };
  blockWidgetIntegrations: {
    [blockId: string]: BlockWidgetIntegrationsByBlockIdState;
  };
}>;

export type BlockWidgetIntegrationsByBlockIdState = {
  data: Readonly<WidgetIntegration[]>;
  getBlockWidgetIntegrationsAsyncState: AsyncState;
  errorGetBlockWidgetIntegrations: string;
  errorAddWidgetIntegration: string;
};

export type AsyncState = 'initial' | 'loading' | 'success' | 'failed';

export enum ListSupportedProviders {
  webhook = 'webhook',
  turnitin = 'turnitin',
}

export type WidgetIntegrationProvider = {
  id: string;
  provider: ListSupportedProviders;
  name: string;
};

export type WidgetIntegration =
  | TurnitinWidgetIntegration
  | WebhookWidgetIntegration;

export type TurnitinWidgetIntegration = {
  name: string;
  enabled: boolean;
  provider: ListSupportedProviders.turnitin;
  widgetIntegrationProviderId: string;
  id: string;
  settings: TurnitinIntegrationSettings;
};

export type WebhookWidgetIntegration = {
  name: string;
  enabled: boolean;
  provider: ListSupportedProviders.webhook;
  widgetIntegrationProviderId: string;
  id: string;
  settings: WebhookIntegrationSettings;
};

export type ProviderSettings =
  | TurnitinIntegrationSettings
  | WebhookIntegrationSettings;

export type TurnitinIntegrationSettings = {
  scoreWarningThreshold: number;
};

export type WebhookIntegrationSettings = {
  endpointUrl: string;
};

export type AddWidgetIntegrationPayload = {
  pagePath: string;
  blockID: string;
  widgetIntegrationProviderId: string;
  settings: ProviderSettings;
};

export type RemoveWidgetIntegrationPayload = {
  pagePath: string;
  blockID: string;
  widgetIntegrationId: string;
};
